import React, {Fragment, memo} from 'react'
import PropTypes from 'prop-types'
import {cn} from '@/lib/utils'
import {useLocation} from 'react-router-dom'

export const BANNER_TYPES = {
    FILTERS: 'Filters',
    LINK_AND_IMAGE: 'Link and Image'
}
export const TRANSPAENT_IMAGE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export const CategoryFilters = memo(({attributes, className, type, list, links}) => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    return (
        <div {...attributes} className="flex flex-wrap w-full overflow-hidden overflow-x-auto">
            <div
                className={cn(
                    'flex flex-row gap-8 mx-0 lg:mx-auto w-auto text-blue-05 min-w-[auto]  justify-center  items-baseline',
                    'font-medium ',
                    'my-2 mx-[5%] p-0',
                    '[--item-width:140px] [--item-height:140px]',
                    'lg:[--item-width:166px] lg:[--item-height:166px]',
                    className
                )}
                data-testid="category-filters"
            >
                {/* Link and Image Banner */}
                {type === BANNER_TYPES.LINK_AND_IMAGE &&
                    links?.map((item, index) => (
                        <div
                            key={`category-filter-${index}`}
                            className="flex shrink-0 flex-col items-center justify-center  flex-1  w-[--item-width]  text-center "
                        >
                            <a
                                key={`category-filter-${index}-link`}
                                href={item.Link}
                                aria-label={`Filter by "${item?.['Label']}"`}
                                data-testid="category-filters-link"
                                className="flex shrink-0 items-center justify-center w-[--item-width] h-[--item-height] text-2xl text-center text-blue-500 rounded-full flex-cal hover:underline bg-gray-02/25"
                            >
                                <img
                                    src={item?.['Image'] ? item?.['Image'] : TRANSPAENT_IMAGE}
                                    alt={item?.['Label']}
                                    className="object-cover w-full h-full m-6 rounded-full"
                                />
                            </a>
                            <spam className={'uppercase text-indigo-04'}>{item?.['Label']}</spam>
                        </div>
                    ))}
                {/* Filters Banner */}
                {type === BANNER_TYPES.FILTERS &&
                    list?.map((item, index) => (
                        <a
                            key={`category-filter-${index}`}
                            href={`?${applyFilter(searchParams, item).toString()}`}
                            aria-label={`Filter by "${item?.['Filter Label']}"`}
                            data-testid="category-filters-link"
                            className="flex shrink-0 flex-0 items-center justify-center p-10 text-2xl  text-center text-blue-500 rounded-full w-[--item-width] h-[--item-height] hover:underline bg-gray-02/25"
                        >
                            {item?.['Filter Label']}
                        </a>
                    ))}
            </div>
        </div>
    )
})
CategoryFilters.displayName = 'CategoryFilters'
CategoryFilters.propTypes = {
    attributes: PropTypes.object,
    className: PropTypes.string,
    type: PropTypes.string,
    list: PropTypes.arrayOf(PropTypes.object),
    links: PropTypes.arrayOf(PropTypes.object)
}

/**
 * Applies the given filter object to the provided URLSearchParams instance and returns a new URLSearchParams object.
 *
 * @param searchParams - The current URLSearchParams instance to apply the filter to.
 * @param filter - An object containing filter criteria. Supported keys:
 *   - 'Maximum Price': Sets the 'pmax' query parameter.
 *   - 'Minimum Price': Sets the 'pmin' query parameter.
 *   - 'Search parameters': A query string of additional parameters to set.
 * @returns A new URLSearchParams instance with the filter applied.
 * @throws Error if searchParams is not an instance of URLSearchParams.
 */
const applyFilter = (searchParams, filter) => {
    if (!(searchParams instanceof URLSearchParams)) {
        throw new Error('searchParams must be an instance of URLSearchParams')
    }
    if (!filter || typeof filter !== 'object') {
        return searchParams
    }
    const params = new URLSearchParams(searchParams.toString())
    if (filter?.['Maximum Price']) {
        params.set('pmax', filter['Maximum Price'])
    }
    if (filter?.['Minimum Price']) {
        params.set('pmin', filter['Minimum Price'])
    }
    if (filter?.['Search parameters']) {
        new URLSearchParams(filter['Search parameters']).forEach((value, key) => {
            params.set(key, value)
        })
    }

    return params
}
